<template>
    <div class="apply">
        <a href="http://www.fufentong.com/user/apply.html"><img src="static/apply.png" alt=""></a>
    </div>
</template>

<script>
    export default {
        name: "apply"
    }
</script>

<style scoped lang="stylus">
    .apply
        position fixed
        bottom 180px
        z-index 1
</style>